import React from 'react';
import { testimonials } from '../data/matematik';
export function Testimonials() {
  // Hidden until authentic BILLEDKLAR reviews are added in data/billedklar.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-284" data-mp="3fym7sltdl44v">
      <div className="mx-auto max-w-6xl" data-id="element-285" data-mp="3azj9dk7whw5v">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-286" data-mp="3ayqcrc2non1g">
          Det siger <em className="text-rose-600" data-id="element-287" data-mp="32061gvzfdfn9">lærerne</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-288" data-mp="31yl8vbwo86s1">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-289" data-mp="2s1q8engu7wb4">
              <div className="text-sm text-amber-500" aria-label="5 / 5 stjerner" data-id="element-290" data-mp="2s3jhsaiu4umt">
                <span aria-hidden="true" data-id="element-291" data-mp="v85b00rzzj4d">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-292" data-mp="qa3pzab0h9q9">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-293" data-mp="h8145e8mjyfq">
                <span className="font-semibold text-slate-900" data-id="element-294" data-mp="m62os3lp85tb">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-295" data-mp="78aa1dnz7lg6"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}